module.exports = __webpack_public_path__ + "img/parkIndustrySolution_EN.jpg";